import { render, staticRenderFns } from "./data87.vue?vue&type=template&id=78c121f4&scoped=true"
import script from "./data87.vue?vue&type=script&lang=js"
export * from "./data87.vue?vue&type=script&lang=js"
import style1 from "./data87.vue?vue&type=style&index=1&id=78c121f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c121f4",
  null
  
)

export default component.exports